// class for defining the amzn user-agent
export default UserAgent; // constructor

function UserAgent() {} // public


UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';